import { render, staticRenderFns } from "./OfisproHomeView.vue?vue&type=template&id=55e20ba2&scoped=true&class=pa-0"
import script from "./OfisproHomeView.vue?vue&type=script&lang=ts"
export * from "./OfisproHomeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e20ba2",
  null
  
)

export default component.exports